/* ============================================================
   ATHLETE FRESH — v2 interaction layer (vanilla, no libraries)
   Liquid-portable. Data = the real 7-SKU canon. No fabricated sports/causes.
   2026-07-05: pruned dead v1-hero code (initHero/initHeroCollapse/initScroll),
   dropped GSAP/ScrollTrigger/Lenis (nothing on the live pages used them),
   and deleted initUGC (placeholder cells that looked like fake UGC —
   AF never ships synthetic proof).
   ============================================================ */
(function(){
'use strict';

window.AF_CONFIG = window.AF_CONFIG || {};

/* ---------- DATA: 7-SKU canon ($29.99 · 60 uses · 5-ingredient enzyme) ---------- */
var PRODUCTS = [
  {sku:'Performance', vertical:'All Sport',                 type:'Detergent',     status:'live', flagship:true, handle:'/products/af-performance-detergent',
   tag:'The all-sport flagship.',
   desc:'Built for the pile that follows a full week of training. The five-ingredient enzyme formula lifts sweat, body oil, and bacteria out of synthetic fabric — and protects the stretch and wicking you paid for.',
   pills:['60 USES','$0.50 / LOAD','5 INGREDIENTS','PLANT-DERIVED','UNSCENTED']},
  {sku:'Revive', vertical:'Restore Soak', type:'Pre-Wash Soak', status:'live', handle:'/products/af-revive-pre-wash-soak',
   tag:'Revive clothes back to life.',
   desc:'The original restore soak. Bucket or sink, no machine needed. Brings tired, embedded-odor gear back to life by breaking the trapped compounds down at the source.',
   pills:['PRE-WASH SOAK','NO MACHINE','5 INGREDIENTS','PLANT-DERIVED']},
  {sku:'Greenside', vertical:'Golf', type:'Detergent', status:'live', handle:'/products/af-greenside-detergent',
   tag:'Clubhouse-clean, every round.',
   desc:'Grass stain, cart grime, Sunday best. Keeps the polo looking like it never left the clubhouse — clean, unscented, and ready to wear.',
   pills:['60 USES','$0.50 / LOAD','5 INGREDIENTS','UNSCENTED']},
  {sku:'Studio', vertical:'Studio / Athleisure', type:'Detergent', status:'soon', handle:'/products/af-studio',
   tag:'Studio to street, wash to wear.',
   desc:'Safe on luxury and technical fabrics, with a clean finish that never bonds fragrance into the weave. Studio to street, wash to wear.',
   pills:['60 USES','$0.50 / LOAD','5 INGREDIENTS','GENTLE ON TECH']},
  {sku:'BackCountry', vertical:'Hunting / Backcountry', type:'Detergent', status:'soon', handle:'/products/af-backcountry',
   tag:'Zero scent. Zero trace.',
   desc:'Certified zero scent profile. No UV brighteners, no residue — formulated so nothing follows you into the field.',
   pills:['60 USES','ZERO SCENT','NO UV BRIGHTENERS','PLANT-DERIVED']},
  {sku:'Pure', vertical:'Baby · Sensitive Skin', type:'Detergent', status:'soon', handle:'/products/af-pure',
   tag:'5 ingredients. Nothing extra.',
   desc:'Completely fragrance-free and gentle enough for baby and sensitive skin at every age. Five ingredients. Nothing extra.',
   pills:['60 USES','FRAGRANCE-FREE','5 INGREDIENTS','SENSITIVE SKIN']},
  {sku:'Workhorse', vertical:'Blue Collar · Trades', type:'Detergent', status:'soon', handle:'/products/af-workhorse',
   tag:'Built for an honest day’s work.',
   desc:'Grease, grime, and a full shift. Workhorse handles the whole pile and keeps work gear lasting longer.',
   pills:['60 USES','$0.50 / LOAD','5 INGREDIENTS','HEAVY DUTY']}
];

/* Liquid-rendered override (af-verticals.liquid blocks) */
(function(){
  var el=document.getElementById('af-products-data');
  if(!el) return;
  try{ var d=JSON.parse(el.textContent); if(d && d.length) PRODUCTS=d; }catch(e){}
})();

/* ---------- VIDEO LAYER ----------
   Feature-panel fallback video (section markup normally supplies its own). */
var VIDEO_SHOW = window.AF_CONFIG.videoShow || '';

var $  = function(s,c){return (c||document).querySelector(s);};
var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var touch  = window.matchMedia('(hover:none),(pointer:coarse)').matches;
var n2 = function(i){return (i<9?'0':'')+(i+1);};
var designMode = !!(window.Shopify && window.Shopify.designMode);

/* ============================================================ CURSOR (understated) */
function initCursor(){
  if(touch) return;
  var dot=$('#af-cur-dot'), ring=$('#af-cur-ring'), label=$('#af-cur-label');
  var rx=0,ry=0,tx=0,ty=0;
  if(label) label.textContent='▶';
  document.addEventListener('mousemove',function(e){ tx=e.clientX;ty=e.clientY; dot.style.left=tx+'px';dot.style.top=ty+'px'; });
  (function loop(){ rx+=(tx-rx)*0.16; ry+=(ty-ry)*0.16; ring.style.left=rx+'px'; ring.style.top=ry+'px'; requestAnimationFrame(loop); })();
  document.addEventListener('mouseover',function(e){
    var media=e.target.closest('.af-feat-media');
    var link=e.target.closest('a,button,.af-strip-item,.af-box,.af-buy,[data-mag]');
    ring.classList.toggle('af-play', !!media);
    ring.classList.toggle('af-hot', !media && !!link);
  });
}

/* ============================================================ MAGNETIC */
function initMagnetic(){
  if(touch) return;
  $$('[data-mag]').forEach(function(el){
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect();
      var mx=e.clientX-(r.left+r.width/2), my=e.clientY-(r.top+r.height/2);
      el.style.transform='translate('+(mx*0.15)+'px,'+(my*0.2)+'px)';
    });
    el.addEventListener('mouseleave',function(){ el.style.transform=''; });
  });
}

/* ============================================================ GRADIENT ILLUMINATION (centerpiece) */
function initGradient(){
  var h=$('#af-illum-h'); if(!h) return;
  if(reduce){ h.style.backgroundPosition='0% 0'; return; }
  function upd(){ var r=h.getBoundingClientRect(), vh=window.innerHeight||1; var p=1-((r.top-vh*0.18)/(vh*0.62)); p=Math.max(0,Math.min(1,p)); h.style.backgroundPosition=(100-p*100)+'% 0'; }
  upd(); window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); setTimeout(upd,300);
}

/* ============================================================ REVEAL + COUNT */
function countUp(el){
  var target=parseFloat(el.getAttribute('data-count')), dec=parseInt(el.getAttribute('data-dec')||'0',10), suf=el.getAttribute('data-suffix')||'';
  if(reduce){ el.textContent=target.toFixed(dec)+suf; return; }
  var start=performance.now(), dur=1400;
  (function step(now){ var p=Math.min((now-start)/dur,1), e=1-Math.pow(1-p,3), v=target*e; el.textContent=v.toFixed(dec)+suf; if(p<1)requestAnimationFrame(step); })(start);
}
function initReveals(){
  if(reduce){ $$('.af-reveal').forEach(function(e){e.classList.add('af-in');}); $$('.af-val-n').forEach(countUp); return; }
  function check(){
    var vh=window.innerHeight||document.documentElement.clientHeight;
    $$('.af-reveal:not(.af-in)').forEach(function(e){ var r=e.getBoundingClientRect(); if(r.top<vh*0.9&&r.bottom>0){ e.classList.add('af-in'); } });
    $$('.af-val-n:not([data-done])').forEach(function(e){ var r=e.getBoundingClientRect(); if(r.top<vh*0.88&&r.bottom>0){ e.setAttribute('data-done','1'); countUp(e); } });
  }
  check();
  window.addEventListener('scroll',check,{passive:true});
  window.addEventListener('resize',check);
  setTimeout(check,400); setTimeout(check,1200);
}

/* ============================================================ NAV (scroll-adaptive + progress) */
function initNav(){
  var nav=$('#af-nav'); if(!nav) return;
  var prog=$('#af-nav-prog');
  var mob=$('#af-mobile');
  var lastY=window.scrollY, h=document.documentElement.scrollHeight-window.innerHeight;
  window.addEventListener('resize',function(){ h=document.documentElement.scrollHeight-window.innerHeight; },{passive:true});
  function upd(){
    var y=window.scrollY;
    nav.classList.toggle('af-stuck', y>40);
    // nav condenses away on scroll-down, returns on scroll-up; never hide while mobile menu open
    if(!(mob&&mob.classList.contains('af-open'))){
      if(y>lastY && y>320) nav.classList.add('af-nav-hidden');
      else if(y<lastY) nav.classList.remove('af-nav-hidden');
    }
    if(prog) prog.style.setProperty('--afp', (h>0?Math.min(100,(y/h)*100):0).toFixed(2)+'%');
    lastY=y;
  }
  // direct, lightweight handler (no rAF gate — the work is a couple class toggles + one style write)
  window.addEventListener('scroll',upd,{passive:true});
  document.addEventListener('af:scroll',upd);
  upd();
  $('#af-burger').addEventListener('click',function(){ mob.classList.add('af-open'); });
  $('#af-mobile-close').addEventListener('click',function(){ mob.classList.remove('af-open'); });
  $$('#af-mobile a').forEach(function(a){ a.addEventListener('click',function(){ mob.classList.remove('af-open'); }); });
  var c=$('#af-cart-n'); if(c && typeof window.AF_CONFIG.cartCount!=='undefined') c.textContent=window.AF_CONFIG.cartCount;
}

/* ============================================================ KINETIC TITLES (per-word rise on reveal) */
function initKineticTitles(){
  if(reduce) return;
  $$('.af-section-title').forEach(function(t){
    if(t.getAttribute('data-af-kw')) return;
    t.setAttribute('data-af-kw','1');
    var lines=Array.prototype.slice.call(t.childNodes);
    // rebuild text nodes into word spans, preserving <br>
    var frag=document.createDocumentFragment();
    lines.forEach(function(node){
      if(node.nodeType===3){ // text
        node.textContent.split(/(\s+)/).forEach(function(tok){
          if(tok.trim()===''){ frag.appendChild(document.createTextNode(tok)); return; }
          var w=document.createElement('span'); w.className='af-kw';
          var inner=document.createElement('span'); inner.textContent=tok;
          w.appendChild(inner); frag.appendChild(w);
        });
      } else { frag.appendChild(node.cloneNode(true)); }
    });
    t.innerHTML=''; t.appendChild(frag);
    // stagger delay per word
    $$('.af-kw>span', t).forEach(function(sp,i){ sp.style.transitionDelay=(i*0.05)+'s'; });
  });
}

/* ============================================================ SPORT STRIP (af-verticals, if re-enabled) */
function initStrip(){
  var strip=$('#af-strip'); if(!strip) return;
  strip.innerHTML=PRODUCTS.map(function(v,i){
    return '<button class="af-strip-item'+(i===0?' af-on':'')+'" data-i="'+i+'">'
      +(v.status==='soon'?'<span class="af-strip-soon">Soon</span>':'')
      +'<span class="af-strip-n">'+n2(i)+'</span>'
      +'<span class="af-strip-vert">'+v.vertical+'</span>'
      +'<span class="af-strip-sku">AF '+v.sku+'</span></button>';
  }).join('');
  strip.addEventListener('click',function(e){
    var it=e.target.closest('.af-strip-item'); if(!it)return;
    var dest=document.getElementById('af-lab');
    if(dest){ dest.scrollIntoView({behavior:reduce?'auto':'smooth'}); }
  });
}

/* ============================================================ FEATURE PANELS (JS fallback when section is empty) */
function initFeats(){
  var wrap=$('#af-feats'); if(!wrap) return;
  if(wrap.hasAttribute('data-af-static')||wrap.children.length) return;
  var vmap=window.AF_CONFIG.videoMap||{};
  var html=PRODUCTS.map(function(v,i){
    var vsrc=vmap[v.sku]||VIDEO_SHOW||'';
    var media='<div class="af-feat-media">'
      +(vsrc?'<video autoplay muted loop playsinline src="'+vsrc+'"></video>':'<div class="af-feat-fallback"></div>')
      +'<div class="af-feat-duo"></div>'
      +'<span class="af-feat-vlabel">'+v.vertical+'</span><span class="af-feat-big">'+n2(i)+'</span></div>';
    var soon=v.status==='soon';
    var cta=soon
      ? '<a class="af-btn af-btn--ghost af-feat-cta" href="'+v.handle+'" data-mag>Join the Waitlist <span class="af-arrow">→</span></a>'
      : '<a class="af-btn af-btn--primary af-feat-cta" href="'+v.handle+'" data-mag>Shop AF '+v.sku+' <span class="af-arrow">→</span></a>';
    var body='<div class="af-feat-body af-reveal">'
      +'<div class="af-feat-tag">'+n2(i)+' &mdash; '+v.vertical+'</div>'
      +'<h3 class="af-feat-name">AF '+v.sku+(soon?'<span class="af-soon">Soon</span>':'')+'</h3>'
      +'<p class="af-feat-desc">'+v.desc+'</p>'
      +'<div class="af-pills">'+v.pills.map(function(p){return '<span class="af-pill">'+p+'</span>';}).join('')+'</div>'
      +cta+'</div>';
    return '<section class="af-feat'+(i%2?' rev':'')+'" data-screen-label="AF '+v.sku+'">'+media+body+'</section>';
  }).join('');
  wrap.innerHTML=html;
}

/* ============================================================ MARQUEES */
var marquees=[];
function initMarquees(){
  var m1=$('#af-mq1');
  if(m1){ var items=PRODUCTS.map(function(v){return '<span class="af-mq-item">AF '+v.sku+' <span class="af-mq-dot">●</span> '+v.vertical+'</span>';}).join(''); m1.innerHTML=items+items; }
  var m2=$('#af-mq2');
  if(m2){ var words=(window.AF_CONFIG.marqueeWords&&window.AF_CONFIG.marqueeWords.length)?window.AF_CONFIG.marqueeWords:['A New Spin On Detergent','<em>Clean In The Wash</em>','Scent In The Dryer','<em>5% Gives Back</em>']; var set=words.map(function(w){return '<span class="af-mq-big">'+w+'</span>';}).join(''); m2.innerHTML=set+set; }
  if(reduce) return;
  marquees=[{el:m1,x:0,dir:-1,speed:0.4},{el:m2,x:0,dir:1,speed:0.55}];
  var last=performance.now();
  (function tick(now){
    var dt=Math.min(now-last,50); last=now;
    marquees.forEach(function(m){ if(!m.el)return; var half=m.el.scrollWidth/2||1; m.x+=m.dir*m.speed*(dt/16); if(m.x<=-half)m.x+=half; if(m.x>0)m.x-=half; m.el.style.transform='translateX('+m.x+'px)'; });
    requestAnimationFrame(tick);
  })(last);
}

/* ============================================================ BUNDLE */
function initBundle(){
  // BUNDLE MATH: detergent $29.99 + Dryer Drops $19.99 + Wool Balls $9.99 = $59.97 a la carte; bundle $55.
  // The bundle copy comes from index.json; we do not print a fabricated saving here.
  var was=$('#af-bundle-was'), save=$('#af-bundle-save');
  if(was) was.textContent='';
  if(save) save.textContent='Everything the two-stage system needs, in one box.';
  /* ATC handled by Shopify product links */
}

/* ============================================================ MOTION VERBS (tagging) */
function initVerbs(){
  $$('.af-box,.af-buy,.af-review,.af-val-card').forEach(function(e){ e.classList.add('af-reveal','af-v-scale'); });
  $$('.af-feat-media').forEach(function(e){ e.classList.add('af-reveal','af-v-blur'); });
  $$('.af-section-title,.af-mission-h,#af-illum-h').forEach(function(e){ e.classList.add('af-reveal','af-v-illum'); });
}

/* ============================================================ BOOT */
function boot(){
  [initCursor,initNav,initStrip,initFeats,
   initMarquees,initBundle,initMagnetic,initKineticTitles,initVerbs,initGradient,initReveals
  ].forEach(function(fn){ try{ fn(); }catch(e){ if(window.console&&console.warn)console.warn('AF init skipped:',e.message); } });
  document.body.classList.add('af-loaded');
  window.afReady=true;
}
function runLoader(){
  var loader=$('#af-loader');
  boot(); // build the page behind the curtain
  if(!loader) return;
  var mode=loader.getAttribute('data-mode')||'session';
  var seen=false;
  try{ seen = mode==='session' && sessionStorage.getItem('af-loader-seen')==='1'; }catch(e){}
  if(reduce || mode==='off' || seen || designMode){ loader.style.display='none'; return; }
  try{ sessionStorage.setItem('af-loader-seen','1'); }catch(e){}
  requestAnimationFrame(function(){ loader.classList.add('af-logo-in'); });
  var num=$('#af-ln'), fill=$('#af-lf'), start=null, DUR=1700, done=false;
  function open(){
    if(done) return; done=true;
    if(num)num.textContent='100'; if(fill)fill.style.width='100%';
    loader.classList.add('af-logo-out');
    setTimeout(function(){ loader.classList.add('af-open'); }, 420);
    setTimeout(function(){ loader.style.display='none'; }, 1500);
  }
  function tick(t){
    if(start===null)start=t;
    var p=Math.min((t-start)/DUR,1), v=Math.round(p*100);
    if(num)num.textContent=v; if(fill)fill.style.width=v+'%';
    if(p<1) requestAnimationFrame(tick); else setTimeout(open,280);
  }
  requestAnimationFrame(tick);
  setTimeout(open, 5200); // hard fallback if rAF is throttled/backgrounded
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',runLoader); else runLoader();

if(designMode){
  document.addEventListener('shopify:section:load',function(){
    initNav(); initStrip(); initFeats(); initMarquees();
    initMagnetic(); initVerbs(); initGradient(); initReveals();
  });
}

})();
